module.exports = "<p>\r\n  group-offers works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/calculators/home-loan-comparison-calculator/group-offers/group-offers.component.html
// module id = 690
// module chunks = 8